/**
 * Created by asiulik on 21.12.2017.
 */

define(['jquery', 'masonry'], function($, Masonry){

    function TeasersMosaic(layoutInstance){
        this.layoutInstance = layoutInstance;
    }

    TeasersMosaic.prototype.init = function(){

        var _this = this;

        $('[data-teasers-mosaic]').each(function(index, element) {

            var $element = $(element);
            var $items = $element.find('.teasers__mosaic__element');

            var masonryInstance = new Masonry(element, {
                itemSelector: '.teasers__mosaic__element',
                percentPosition: true,
                columnWidth: '.teaser__width'
            });

            _this.layoutInstance.on('reload', function(){

                //reorderElementWithCurrentBreakpoint($items, this.currentBreak);

            });

            //reorderElementWithCurrentBreakpoint($items, _this.layoutInstance.currentBreak);

            function reorderElementWithCurrentBreakpoint(collection, breakpoint){

                var collectionWithNewOrder = _this.changeDOMOrderFromElementsConfig(
                    collection,
                    breakpoint
                );

                collectionWithNewOrder.detach().appendTo($element);

                masonryInstance.reloadItems();
                masonryInstance.layout();
            }

        })

    };

    TeasersMosaic.prototype.changeDOMOrderFromElementsConfig = function(collection, layoutName){

        return collection.sort(function(a,b){

            var firstOrderValue = $(a).data('orders')[layoutName] || 0;
            var secondOrderValue = $(b).data('orders')[layoutName] || 0;

            return firstOrderValue - secondOrderValue;

        })

    };

    return TeasersMosaic;

});


// WEBPACK FOOTER //
// ./Private/Scripts/modules/teasers/teasersMosaic.js